import groq from 'groq';
import { getConfig } from '@/constants/config';
import { CONTENT_BLOCK_GROUP_PROJECTION } from '@/integrations/sanity/api/projections';
import { sanityFetch } from '@/integrations/sanity/client';
import type { PRIVACY_POLICY_QUERY_RESULT } from '@/integrations/sanity/sanity.types';

const PRIVACY_POLICY_QUERY = groq`*[_type == "privacyPage" && locale == $locale][0] {
  _type,
  heading,
  "contentBlockGroup": categories[0] ${CONTENT_BLOCK_GROUP_PROJECTION}
}`;

export const getPrivacyPolicy = () =>
  sanityFetch<PRIVACY_POLICY_QUERY_RESULT>(PRIVACY_POLICY_QUERY, {
    locale: getConfig().locale,
  });
